import AbstractUploadHelper from "~/ts/library/AbstractUploadHelper";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export default class OperatorApplicationUploadHelper extends AbstractUploadHelper {
    protected getPath(): string {
        return `/json/anonymous/cors/upload`;
    }

    getUrl(): string {
        let q = this.additionalQueryParams;
        if (!q) {
            q = {};
        }
        q.orgId = OperatorAccountStore.data.value.orgId;
        this.setAdditionalQueryParams(q);
        return `${OperatorApiRequest.getHost()}${super.getUrl()}`;
    }

    public static getUrlById(fileId: string | string[]): string {
        return OperatorApiRequest.getHost() + super.getUrlById(fileId);
    }
}